import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useAuth} from '../lib/auth';
import {friendlyError} from '../lib/error-labels';

export default function LoginPage() {
  const {login, user} = useAuth();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (user) {
    navigate('/');
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err: any) {
      // Show the friendly headline; the raw code (if any) is logged
      // for escalation but never displayed to the operator.
      const code = err?.code || null;
      const headline = friendlyError(code, err?.message).headline;
      // eslint-disable-next-line no-console
      console.error('[login]', {code, message: err?.message});
      setError(headline);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <h1>
          {t('app.name')} <span className="accent">{t('app.brand')}</span>
        </h1>
        <p className="subtitle">{t('app.subtitle')}</p>

        <label>
          <span>{t('login.email')}</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </label>
        <label>
          <span>{t('login.password')}</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </label>

        {error && <div className="error">{error}</div>}

        <button type="submit" disabled={busy}>
          {busy ? t('login.submitting') : t('login.submit')}
        </button>
      </form>
    </div>
  );
}
